import { Attendance, DSTIRecord } from "../../../../models/DSTI/site-dsti-list.interface";
import { useEffect, useState } from "react";
import { s3GetUrl } from "../../../../service/s3Service";
import { ProgressSpinner } from "primereact/progressspinner";
import DisplayPhoto from "./DisplayPhoto";
import styles from "../sitedsti.module.scss";

interface DSTIAttendanceProps {
  dstiAttendance?: Attendance[];
}
function DSTIAttendance({ dstiAttendance }: DSTIAttendanceProps) {
  const [photoUrls, setPhotoUrls] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPhotoUrls = async () => {
      if (dstiAttendance && dstiAttendance.length > 0) {
        setLoading(true);
        try {
          const urls = await Promise.all(
            dstiAttendance.map(async employee => {
              return await s3GetUrl(employee.s3_key);
            })
          );
          setPhotoUrls(urls);
        } catch (error) {
          console.error("Error fetching photo URLs:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchPhotoUrls();
  }, [dstiAttendance]);

  if (loading) {
    return <ProgressSpinner />;
  }

  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "1rem",
        }}
      >
        {photoUrls.map((photoUrl, index) => {
          return (
            <div key={index} className={styles["equipment-container"]}>
              <DisplayPhoto url={photoUrl} index={index} />
              <p className={"my-0"}>{dstiAttendance?.[index].employee_full_name ?? "n/a"}</p>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default DSTIAttendance;
